import { Props } from 'docz';
import { Playground } from '@playground';
import { WarningBox } from "../../../../../packages/layout/src/components/warning/warning";
import { useState } from 'react';
import { Button } from '@tpr/core';
import * as React from 'react';
export default {
  Props,
  Playground,
  WarningBox,
  useState,
  Button,
  React
};